import { apiClient } from "./http"

export interface SellerLeadsParams {
  page?: number
  limit?: number
  offset?: number
  status?: string
  search?: string
}

export async function getSellerLeads(token: string, params?: SellerLeadsParams) {
  const { data } = await apiClient.get("/seller-leads", {
    headers: { Authorization: `Bearer ${token}` },
    params,
  })
  return data
}

export async function getSellerLeadById(id: string, token: string) {
  const { data } = await apiClient.get(`/seller-leads/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}

export async function updateSellerLeadStatus(id: string, payload: { status: string; message: string }, token: string) {
  const { data } = await apiClient.patch(`/seller-leads/${id}/status`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}

export async function assignSellerLead(id: string, payload: { adminUserId: string }, token: string) {
  const { data } = await apiClient.patch(`/seller-leads/${id}/assign`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}

export async function addSellerLeadNote(id: string, payload: { message: string }, token: string) {
  const { data } = await apiClient.post(`/seller-leads/${id}/notes`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}

export async function getSellerLeadsCount(token: string) {
  const { data } = await apiClient.get("/seller-leads/counts", {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}

export async function getSellerLeadContact(id: string, token: string) {
  const { data } = await apiClient.get(`/seller-leads/${id}/contact`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}
